import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { beforeNFT, getNFT } from '../nfts/nfts.action';
import FullPageLoader from '../full-page-loader/full-page-loader'
import { ENV } from '../../config/config';
import { makeOfferWeb3, placeBidWeb3, cancelOfferBidWeb3, acceptOfferWeb3, acceptBidWeb3, checkBalance } from './../../utils/web3'
import moment from 'moment';
import Countdown from 'react-countdown';
import SimpleReactValidator from 'simple-react-validator'
import { Modal } from "react-bootstrap";
import { beforeOffer, makeOffer, getOffers, deleteOffer, acceptOffer } from '../offers/offers.action'
import { beforeBid, placeBid, getBids, deleteBid, acceptBid } from '../bids/bids.action'
import { beforeHistory, getHistory } from '../history/history.action'
import { toast } from 'react-toastify';
import InfiniteScroll from 'react-infinite-scroll-component';
import ReactTooltip from 'react-tooltip'
const { globalPlaceholderImage, countDownRenderer, decimalNumberValidator, bscExplorerURL } = ENV
const currencies = (ENV.currencies).filter(elem => elem.showInBuy === true)

const initData = {
    bidBtn: "Place a Bid",
    offerBtn: "Make Offer",
    sellBtn: "Sell"
}

// expiry options
const expiryOptions = [
    { label: '5 Days', value: moment().add(5, "days").format('DD/MM/YYYY') },
    { label: '7 Days', value: moment().add(7, "days").format('DD/MM/YYYY') },
    { label: 'A Month', value: moment().add(1, "months").format('DD/MM/YYYY') },
    { label: 'Custom Date', value: -1 },
]

// make an offer / bid config.
const config1 = {
    price: {
        currency: currencies && currencies.length ? currencies[0].value : 'WETH',
        amount: "",
    },
    expiry: {
        date: expiryOptions[0].value,
        time: moment(new Date()).format("HH:mm"),
        type: 1, // 1 for time & 2 for datetime-local
        datetime: '' // for payload 
    },
    cabi: JSON.stringify(currencies && currencies.length ? currencies[0].abi : []),
    cAddress: currencies && currencies.length ? currencies[0].address : '',
};
class ItemDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userId: ENV.getUserKeys()?._id,
            offers: [],
            offersPagination: null,
            moreCheck: true,
            bids: [],
            bidsPagination: null,
            page: 2,
            nftHistory: [],
            nftHistoryPagination: null,
            rendType: 1,
            errors: '',
            isSubmitted: false,
            formValid: true,
            loader: true,
            nft: null,
            isOpen: false,
            nftConfig: config1, // make an offer / bid config.
            nftId: null
        }
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            messages: {
                required: 'This field is required.'  // will override all messages
            },
        })
    }

    componentDidMount() {
        window.scroll(0, 0)
        const query = new URLSearchParams(window.location.search)
        if (query.get('item')) {
            const nftId = window.atob(query.get('item'))
            this.setState({ nftId })
            if (nftId) {
                this.props.getNFT(nftId);

                const bidQS = ENV.objectToQueryString({ nftId })
                this.props.getBids(bidQS);

                const offerQS = ENV.objectToQueryString({ nftId })
                this.props.getOffers(offerQS);

                const historyQS = ENV.objectToQueryString({ nftId })
                this.props.getHistory(historyQS);
            }
        } else
            this.props.history.push('/explore-all')
    }

    componentDidUpdate() {
        // if (this.props.error)
        //     this.setState({ loader: false })

        if (this.props.nft.nftsAuth) {
            const nft = this.props.nft.nftsData
            this.setState({
                loader: false,
                nft
            }, () => {
                this.props.beforeNFT()
            })
        }

        if (this.props.offer.createAuth) {
            this.setState({
                // loader: false,
                isOpen: false
            }, () => {
                this.props.beforeOffer()
                window.location.reload()
            })
        }

        if (this.props.offer.getAuth) {
            const { offers, pagination } = this.props.offer
            this.props.beforeOffer()

            if (offers.length) {
                this.setState({ loader: false, offers: [...this.state.offers, ...offers], offersPagination: pagination, moreCheck: true }, () => {
                })
            }
            else {
                this.setState({ loader: false, offersPagination: pagination, moreCheck: false }, () => {
                })
            }
        }


        if (this.props.offer.deleteAuth) {
            this.props.beforeOffer()
            window.location.reload()
        }

        if (this.props.bid.createAuth) {
            this.setState({
                // loader: false,
                isOpen: false
            }, () => {
                this.props.beforeBid()
                window.location.reload()
            })
        }

        if (this.props.bid.getAuth) {
            const { bids, pagination, highestBid } = this.props.bid
            let nft = { ...this.state.nft }
            nft.highestBid = highestBid

            this.props.beforeBid()
            if (bids && bids.length) {
                this.setState({ loader: false, bids: [...this.state.bids, ...bids], bidsPagination: pagination, nft, moreCheck: false }, () => {
                })
            }
            else {
                this.setState({ loader: false, bidsPagination: pagination, nft, moreCheck: false }, () => {
                })
            }
        }

        if (this.props.bid.deleteAuth) {
            this.props.beforeBid()
            window.location.reload()
        }

        if (this.props.offer.acceptAuth) {
            this.setState({ loader: false }, () => {
                this.props.beforeOffer()
                const { nft } = this.state
                this.props.history.push(`collection-details/${window.btoa(nft.collection._id)}`)
            })
        }

        if (this.props.bid.acceptAuth) {
            this.setState({ loader: false }, () => {
                this.props.beforeBid()
                const { nft } = this.state
                this.props.history.push(`collection-details/${window.btoa(nft.collection._id)}`)
            })
        }

        if (this.props.nftHistory.getAuth) {
            const { history, pagination } = this.props.nftHistory
            this.props.beforeHistory()

            if (history && history.length) {
                this.setState({ loader: false, nftHistory: [...this.state.nftHistory, ...history], nftHistoryPagination: pagination, moreCheck: true }, () => {
                })
            }
            else {
                this.setState({ loader: false, nftHistoryPagination: pagination, moreCheck: false }, () => {
                })
            }
        }
    }

    getPrice = (currency, amount) => {
        if (currency === 'BNB' || currency === 'WBNB') {
            if (amount && this.props.app.rateAuth) {
                return ENV.convertBnbToUsd(amount, this.props.app.rate)
            }
            else {
                return "0.00"
            }
        }
        else if (currency === 'ANN') {
            if (amount && this.props.app.annRateAuth) {
                return ENV.convertAnnToUsd(amount, this.props.app.annRate)
            }
            else {
                return "0.00"
            }
        }
    }

    openModal = () => {
        if (localStorage.getItem('encuse')) {
            this.setState({ isOpen: true, nftConfig: config1, errors: '' });
        }
        else {
            this.props.history.push('/login')
        }
    }

    closeModal = () => this.setState({ isOpen: false });

    onChange = (e) => {
        const { nftConfig } = this.state;
        const { name, value } = e.target;
        let data = nftConfig;

        const keys = name.split("."); // nftConfig, price, currency
        if (keys && keys[2])
            data[keys[1]][keys[2]] = value;
        else if (keys && keys[1])
            data[keys[1]] = value;

        if (keys && keys[1] === 'price' && keys[2] === 'amount')
            data[keys[1]]['amount'] = Number(value)

        if (keys && keys[1] === 'expiry' && keys[2] === 'date')
            data[keys[1]]['type'] = Number(value) === -1 ? 2 : 1

        // set datetime for days / months 
        if (data.expiry.type === 1)
            data.expiry.datetime = moment(data.expiry.date + ' ' + data.expiry.time, 'DD/MM/YYYY HH:mm')
        // set datetime for custom date
        else if (data.expiry.type === 2) {
            if (Number(value) === -1) {
                data.expiry.time = ''
            }
            else {
                const dateTime = value.split('T')
                data.expiry.datetime = moment(dateTime[0] + ' ' + dateTime[1], 'DD/MM/YYYY HH:mm')
            }
        }
        if (e.target.id === "currency") {
            data.cAddress = e.target.selectedOptions[0].getAttribute('caddress');
            data.cabi = e.target.selectedOptions[0].getAttribute('cabi');
        }
        this.setState({
            nftConfig: {
                ...data
            }
        })
    };

    // submit when a bid is placed or when an offer is made
    submit = async () => {
        this.setState({ isSubmitted: true, formValid: this.validator.allValid() }, () => {
            const { formValid } = this.state
            if (formValid) {
                this.setState({
                    loader: true
                }, async () => {
                    const { nft, nftConfig } = this.state;

                    const payload = {
                        ownerId: nft.owner._id,
                        expiryDate: nftConfig.expiry.datetime,
                        price: nftConfig.price,
                        nftId: nft._id
                    }
                    let _nftData = {
                        tokenId: nft.tokenId,
                        price: nftConfig.price.amount,
                        cabi: nftConfig.cabi,
                        cAddress: nftConfig.cAddress,
                    }
                    let balanceOf = await checkBalance(_nftData);
                    if (parseInt(balanceOf) < nftConfig.price.amount) {
                        toast.error("Your account does not have sufficient amount of the selected token");
                        this.setState({ loader: false });
                        return;
                    }
                    // if selling method is 2 then go for bid
                    if (nft.sellingMethod === 2) { // place a bid 
                        let bidResponse = await placeBidWeb3(_nftData)
                        if (bidResponse) {
                            payload.txHash = bidResponse
                            toast.success("Your bid is placed successfully");
                            this.props.placeBid(payload)
                        }
                        else {
                            toast.error("Failed to place a bid");
                            this.setState({ loader: false });
                        }
                    } else if (nft.sellingMethod === 1) { // make an offer 
                        let offerResponse = await makeOfferWeb3(_nftData);
                        if (offerResponse) {
                            payload.txHash = offerResponse
                            toast.success("Your offer is submitted successfully");
                            this.props.makeOffer(payload)
                        }
                        else {
                            toast.error("Failed to make an offer");
                            this.setState({ loader: false });
                        }
                    }
                })
            } else {
                this.validator.showMessages()
                this.validator.purgeFields()
                this.setState({
                    errors: 'Please fill all required fields in valid format.',
                    formValid: false
                }, () => {
                    window.scroll(0, 0)
                })
            }
        })
    }

    deleteOffer = (offerId) => {
        this.setState({
            loader: true
        }, async () => {
            const { nft } = this.state
            let _nftData = {
                tokenId: nft.tokenId
            }
            let cancelResponse = await cancelOfferBidWeb3(_nftData);
            if (cancelResponse) {
                toast.success("Your offer has been cancelled successfully");
                this.props.deleteOffer(offerId)
            }
            else {
                toast.error("Failed to cancel the offer");
                this.setState({ loader: false });
            }
        })
    }

    deleteBid = (bidId) => {
        this.setState({
            loader: true
        }, async () => {
            const { nft } = this.state
            let _nftData = {
                tokenId: nft.tokenId
            }
            let cancelResponse = await cancelOfferBidWeb3(_nftData);
            if (cancelResponse) {
                toast.success("Your bid has been cancelled successfully");
                this.props.deleteBid(bidId)
            }
            else {
                toast.error("Failed to cancel the bid");
                this.setState({ loader: false });
            }
        })
    }

    acceptOffer = async (offerId, offerByAddress, price, payThrough) => {
        this.setState({
            loader: true
        }, async () => {
            const { nft } = this.state;
            let _nftData = {
                tokenId: nft.tokenId,
                price
            }
            let acceptOfferResponse = await acceptOfferWeb3(_nftData, offerByAddress, payThrough);
            if (acceptOfferResponse) {
                toast.success("Offer is accepted successfully, and ownership is transferred.");
                this.props.acceptOffer({ offerId, txHash: acceptOfferResponse })
            }
            else {
                toast.error("Failed to accept the offer");
                this.setState({ loader: false });
            }
        })
    }

    acceptBid = async (bidId, offerByAddress, price, payThrough) => {
        this.setState({
            loader: true
        }, async () => {
            const { nft } = this.state;
            let _nftData = {
                tokenId: nft.tokenId,
                price
            }
            let acceptBidResponse = await acceptBidWeb3(_nftData, offerByAddress, payThrough);
            if (acceptBidResponse) {
                toast.success("Bid is accepted successfully, and ownership is transferred.");
                this.props.acceptBid({ bidId, txHash: acceptBidResponse })
            }
            else {
                toast.error("Failed to accept the bid");
                this.setState({ loader: false });
            }
        })
    }

    fetchData = () => {
        if (this.state.nftId) {
            if (this.state.rendType === 1) {
                const bidQS = ENV.objectToQueryString({ nftId: this.state.nftId, page: this.state.page })
                this.props.getBids(bidQS);
            }
            else if (this.state.rendType === 2) {
                const qs = ENV.objectToQueryString({ nftId: this.state.nftId, page: this.state.page })
                this.props.getOffers(qs)
            }
            else if (this.state.rendType === 3) {
                const qs = ENV.objectToQueryString({ nftId: this.state.nftId, page: this.state.page })
                this.props.getHistory(qs);
            }
        }
        let page = this.state.page + 1
        this.setState({
            page
        })

    }

    rendContent() {
        let { bids, offers, nftHistory, moreCheck, userId, nft } = this.state
        if (this.state.rendType === 1) {
            return (
                <div className="tab-pane show active" id="bids">
                    <ul className="list-unstyled">
                        {
                            bids && bids.length > 0 ?
                                <InfiniteScroll
                                    dataLength={bids.length}
                                    next={this.fetchData}
                                    hasMore={moreCheck}
                                    loader={<h4>Loading...</h4>}
                                >
                                    {
                                        bids.map((item, idx) => {
                                            return (
                                                <li key={`bid_${idx}`} className="single-tab-list d-flex justify-content-between align-items-start w-100">
                                                    <img className="avatar-sm rounded-circle mr-3" src={item.bidBy.profilePhoto} alt="" />
                                                    <div className="d-flex justify-content-between flex-fill">
                                                        <p className="m-0 mr-3 flex-fill">
                                                            Bid listed for <strong>{item.price.amount} {item.price.currency}</strong> {moment(item.createdAt).fromNow()} <br />by <Link to={`/author/${item.bidBy._id}`}>@{item.bidBy.username}</Link>
                                                        </p>
                                                        <div className="d-flex">
                                                            {
                                                                userId === item.bidBy._id &&
                                                                <div className="ml-auto" onClick={() => this.deleteBid(item._id)} data-toggle="tooltip" title="Delete">
                                                                    <i className="cursor-pointer fa fa-times text-danger" aria-hidden="true" />
                                                                </div>
                                                            }
                                                            {
                                                                userId === nft.owner?._id &&
                                                                <>
                                                                    <div className="ml-auto" onClick={() => this.acceptBid(item._id, item.bidBy.address, item.price.amount, ENV.tokenNameToValue[item.price.currency] ? ENV.tokenNameToValue[item.price.currency] : 2)} data-toggle="tooltip" title="Accept">
                                                                        <i className="cursor-pointer fa fa-check text-success" aria-hidden="true" />
                                                                    </div>
                                                                    {/* IN PROGRESS */}
                                                                    {/* <div className="ml-auto" onClick={() => this.counterBid(item._id, item.bidBy.address, item.price.amount)} data-toggle="tooltip" title="Accept">
                                                                                                    <i className="cursor-pointer fa fa-check text-success" aria-hidden="true" />
                                                                                                </div> */}
                                                                </>
                                                            }
                                                            {
                                                                item.txHash &&
                                                                <a className="ml-3" target="_blank" href={`${bscExplorerURL}${item.txHash}`} data-toggle="tooltip" title="Transaction Details">
                                                                    <i className="cursor-pointer fa fa-info text-info" aria-hidden="true" />
                                                                </a>
                                                            }
                                                        </div>
                                                    </div>
                                                </li>
                                            );
                                        })
                                    }
                                </InfiniteScroll>
                                :
                                <div className="mt-3">No bids found</div>
                        }
                    </ul>
                </div>
            )
        }
        else if (this.state.rendType === 2) {
            return (
                <div className="tab-pane show active" id="offers">
                    <ul className="list-unstyled">
                        {
                            offers && offers.length > 0 ?
                                <InfiniteScroll
                                    dataLength={offers.length}
                                    next={this.fetchData}
                                    hasMore={moreCheck}
                                    loader={<h4>Loading...</h4>}
                                >
                                    {
                                        offers.map((item, idx) => {
                                            return (
                                                <li key={`offer_${idx}`} className="single-tab-list d-flex align-items-start w-100">
                                                    <img className="avatar-sm rounded-circle mr-3" src={item.offerBy.profilePhoto} alt="" />
                                                    <div className="d-flex justify-content-between flex-fill">
                                                        <p className="m-0 mr-3 flex-fill">
                                                            Offer listed for <strong>{item.price.amount} {item.price.currency}</strong> {moment(item.createdAt).fromNow()} <br />by <Link to={`/author/${item.offerBy._id}`}>@{item.offerBy.username}</Link>
                                                        </p>
                                                        <div className="d-flex">
                                                            {
                                                                userId === item.offerBy._id &&
                                                                <div className="ml-auto" onClick={() => this.deleteOffer(item._id)} data-toggle="tooltip" title="Remove">
                                                                    <i className="cursor-pointer fa fa-times text-danger" aria-hidden="true" />
                                                                </div>
                                                            }
                                                            {
                                                                userId === nft.owner?._id &&
                                                                <div className="ml-auto" onClick={() => this.acceptOffer(item._id, item.offerBy.address, item.price.amount, ENV.tokenNameToValue[item.price.currency] ? ENV.tokenNameToValue[item.price.currency] : 2)} data-toggle="tooltip" title="Accept">
                                                                    <i className="cursor-pointer fa fa-check text-success" aria-hidden="true" />
                                                                </div>
                                                            }
                                                            {
                                                                item.txHash &&
                                                                <a className="ml-3" target="_blank" href={`${bscExplorerURL}${item.txHash}`} data-toggle="tooltip" title="Transaction Details">
                                                                    <i className="cursor-pointer fa fa-info text-info" aria-hidden="true" />
                                                                </a>
                                                            }
                                                        </div>
                                                    </div>
                                                </li>
                                            );
                                        })
                                    }
                                </InfiniteScroll>
                                : <div className="mt-3">No offers found</div>
                        }
                    </ul>
                </div>
            )
        }
        else if (this.state.rendType === 3) {
            return (
                <div className="tab-pane show active" id="history">
                    <ul className="list-unstyled">
                        {
                            nftHistory && nftHistory.length > 0 ?
                                <InfiniteScroll
                                    dataLength={nftHistory.length}
                                    next={this.fetchData}
                                    hasMore={moreCheck}
                                    loader={<h4>Loading...</h4>}
                                >
                                    {
                                        nftHistory.map((item, idx) => {
                                            return (
                                                <li key={`history_${idx}`} className="single-tab-list d-flex align-items-start w-100">
                                                    {
                                                        item.seller ?
                                                            <p className="m-0">
                                                                Ownership transferred from <Link to={`/author/${item.seller._id}`}>{item.seller.username}</Link> to <Link to={`/author/${item.buyer._id}`}>{item.buyer.username}</Link> for <strong>{item.price.amount} {item.price.currency}</strong>
                                                            </p>
                                                            :
                                                            'No history found'
                                                    }
                                                    {
                                                        item.txHash &&
                                                        <a className="ml-auto" target="_blank" href={`${bscExplorerURL}${item.txHash}`} data-toggle="tooltip" title="Transaction Details">
                                                            <i className="cursor-pointer fa fa-info text-info" aria-hidden="true" />
                                                        </a>
                                                    }
                                                </li>
                                            );
                                        })
                                    }
                                </InfiniteScroll>
                                :
                                <div className="mt-3">No history found</div>
                        }
                    </ul>
                </div>
            )
        }
        else if (this.state.rendType === 4) {
            return (
                <div className="tab-pane  show active" id="details">
                    <div className="owner-meta d-flex align-items-center mt-3">
                        <span>Owner</span>
                        <Link className="owner d-flex align-items-center ml-2" to={`/author/${nft.owner?._id}`}>
                            <img className="avatar-sm rounded-circle" src={nft.owner?.profilePhoto ? nft.owner.profilePhoto : globalPlaceholderImage} alt="img" />
                            <h6 className="ml-2">{nft.owner?.username}</h6>
                        </Link>
                    </div>
                    <p className="mt-2">Created : {moment(nft.createdAt).format('DD MMM YYYY')
                    }</p>
                    {
                        nft.txHash &&
                        <a target="_blank" href={`${bscExplorerURL}${nft.txHash}`}>
                            View Transaction Details
                        </a>
                    }
                </div>
            )
        }



    }

    render() {
        const { loader, nft, nftConfig, isSubmitted, errors, userId } = this.state

        return (
            <>
                <section className="item-details-area padding-wrapper pb-0">
                    {
                        loader ?
                            <FullPageLoader /> :
                            <>
                                {
                                    nft &&
                                    <div className="container">
                                        <div className="row justify-content-between">
                                            <div className="col-12 col-lg-5">
                                                <div className="item-info">
                                                    <div className="item-thumb text-center">
                                                        <img src={nft.image} alt="img" />
                                                    </div>
                                                    {
                                                        nft.auctionEndDate &&
                                                        <div className="card no-hover countdown-times mt-4">
                                                            <Countdown
                                                                date={Date.parse(nft.auctionEndDate) + 10000}
                                                                renderer={countDownRenderer}
                                                            />
                                                        </div>
                                                    }
                                                    {/* Tabs */}
                                                    <ul className="netstorm-tab nav nav-tabs mt-4" id="nav-tab">
                                                        <li>
                                                            <a className={this.state.rendType === 1 ? "active" : ''} id="bids-tab" data-toggle="pill" href="#bids" onClick={() => { this.setState({ rendType: 1, page: 2, moreCheck: true }) }}>
                                                                <h5 className="m-0">Bids</h5>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a className={this.state.rendType === 2 ? "active" : ''} id="offers-tab" data-toggle="pill" href="#offers" onClick={() => { this.setState({ rendType: 2, page: 2, moreCheck: true }); }}>
                                                                <h5 className="m-0">Offers</h5>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a className={this.state.rendType === 3 ? "active" : ''} id="history-tab" data-toggle="pill" href="#history" onClick={() => { this.setState({ rendType: 3, page: 2, moreCheck: true }) }}>
                                                                <h5 className="m-0">History</h5>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a className={this.state.rendType === 4 ? "active" : ''} id="details-tab" data-toggle="pill" href="#details" onClick={() => { this.setState({ rendType: 4 }) }}>
                                                                <h5 className="m-0">Details</h5>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                    {/* Tab Content */}
                                                    <div className="tab-content" id="nav-tabContent">
                                                        {
                                                            this.rendContent()
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-6">
                                                <div className="content mt-5 mt-lg-0">
                                                    <h3 className="m-0">{nft.name}</h3>
                                                    <p>{nft.description}</p>

                                                    {/* Owner */}
                                                    <div className="owner d-flex align-items-center">
                                                        <span>Owned By</span>
                                                        <Link className="owner-meta d-flex align-items-center ml-3" to={`/author/${nft.owner?._id}`}>
                                                            <img className="avatar-sm rounded-circle" src={nft.owner?.profilePhoto || globalPlaceholderImage} alt="Owner Avatar" />
                                                            <h6 className="ml-2">{nft.owner?.username}</h6>
                                                        </Link>
                                                    </div>
                                                    {/* Item Info List */}
                                                    <div className="item-info-list mt-4">
                                                        <ul className="list-unstyled">
                                                            <li className="price d-flex justify-content-between">
                                                                <span>Current Price {nft.currentPrice || 0} {ENV.currency}</span>
                                                                <span>${nft.currentPrice && this.props.app.rateAuth ? ENV.convertBnbToUsd(nft.currentPrice, this.props.app.rate) : "0.00"}</span>
                                                                {/* <span>{nft.sold} of {nft.copies}</span> */}
                                                            </li>
                                                            <li>
                                                                <span>Size </span>
                                                                <span>{nft.size}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="row items">
                                                        {/* Creator */}
                                                        <div className="col-12 col-md-6 item px-lg-2">
                                                            <div className="card no-hover">
                                                                <div className="single-seller d-flex align-items-center">
                                                                    <Link to={`/author/${nft.creator?._id}`}>
                                                                        <img className="avatar-md rounded-circle" src={nft.creator?.profilePhoto || globalPlaceholderImage} alt="Creator Avatar" />
                                                                    </Link>
                                                                    <div className="seller-info ml-3">
                                                                        <Link className="seller mb-2" to={`/author/${nft.creator?._id}`} data-effect="float" data-tip={nft.creator?.username}>{nft.creator?.username}</Link>
                                                                        <span>Creator</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* Collection */}
                                                        <div className="col-12 col-md-6 item px-lg-2">
                                                            <div className="card no-hover">
                                                                <div className="single-seller d-flex align-items-center">
                                                                    <Link to={`collection-details/${window.btoa(nft.collection?._id)}`}>
                                                                        <img className="avatar-md rounded-circle" src={nft.collection?.image} alt="img" />
                                                                    </Link>
                                                                    <div className="seller-info ml-3">
                                                                        <Link className="seller mb-2" to={`collection-details/${window.btoa(nft.collection?._id)}`} data-effect="float" data-tip={nft.collection?.name}>{nft.collection?.name}</Link>
                                                                        <span>Collection</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 item px-lg-2">
                                                            <div className="card no-hover">
                                                                <h4 className="mt-0 mb-2">Highest Bid</h4>
                                                                <div className="price d-flex justify-content-between align-items-center">
                                                                    <span>{nft.highestBid ? `${nft.highestBid?.amount} ${nft.highestBid?.currency}` : 'N/A'}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <ReactTooltip />
                                                    </div>
                                                    {
                                                        nft.owner?._id === userId ?
                                                            <>
                                                                {
                                                                    !nft.sellingMethod &&
                                                                    <Link className="d-block btn btn-bordered-white mt-4 mb-4 w-100" to={`/sell-item/${window.btoa(nft._id)}`}>{initData.sellBtn}</Link>
                                                                }
                                                            </>
                                                            :
                                                            <>
                                                                {
                                                                    nft.sellingMethod
                                                                    &&
                                                                    <>
                                                                        <button className="d-block btn btn-bordered-white mt-4 w-100" onClick={this.openModal}>{nft.sellingMethod === 2 ? initData.bidBtn : initData.offerBtn}</button>
                                                                    </>
                                                                }
                                                            </>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </>

                    }
                </section>
                <div className="modal-wrapper ">
                    {
                        nft &&
                        <Modal
                            centered
                            size="lg"
                            className="offer-modal"
                            show={this.state.isOpen}
                            onHide={this.closeModal}
                        >
                            <Modal.Header className="text-center modal-title-wrapper">
                                <Modal.Title>
                                    {nft.sellingMethod === 2 ? 'Place A Bid' : 'Make An Offer'}
                                </Modal.Title>
                            </Modal.Header>
                            {
                                isSubmitted && errors &&
                                <Modal.Body className="row pt-2 pb-0">
                                    <div className="col-12">
                                        <span id="nft-err" className="form-error-msg text-danger">{errors}</span>
                                    </div>
                                </Modal.Body>
                            }
                            <Modal.Body>
                                <div className="price-wrapper d-flex">
                                    <div className="price-text position-relative">
                                        <div className="text-white mb-2 absolute-wrapper">
                                            <b>Price</b>
                                        </div>
                                        <div className="text-right mb-2" data-toggle="tooltip" title="lorem">
                                            <i className="fas fa-exclamation-circle ml-2" />
                                        </div>
                                        <div className="d-flex">
                                            <select className="form-control" id="currency" name="nftConfig.price.currency" onChange={(e) => this.onChange(e)}>
                                                {
                                                    currencies && currencies.map((currency, index) => {
                                                        return (
                                                            <option key={index} value={currency.symbol} caddress={currency.address} cabi={JSON.stringify(currency.abi)}>{currency.symbol}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                            <input type="text" placeholder="Amount" className="amount-btn ml-3" name="nftConfig.price.amount" style={{ borderRadius: "4px" }} onChange={(e) => this.onChange(e)} onKeyDown={(e) => decimalNumberValidator(e)} defaultValue={nftConfig.price.amount} required />
                                            <div className="text-right mb-2 dollar-wrapper">
                                                $ {
                                                    // nftConfig.price.currency === 'BNB' ?
                                                    //     nftConfig.price.amount && this.props.app.rateAuth ?
                                                    //         ENV.convertBnbToUsd(nftConfig.price.amount, this.props.app.rate) :
                                                    //         "0.00" :
                                                    //     'kjkdhad'
                                                    this.getPrice(nftConfig.price.currency, nftConfig.price.amount)
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Body className="text-danger">{this.validator.message('amount', nftConfig.price.amount, 'required')}</Modal.Body>
                            <Modal.Body className="" style={{ flexDirection: "column", display: "block", height: "auto" }}>
                                <div className="offer-expiration-wrapper text-white mb-2">
                                    <b>Offer Expiration</b>
                                </div>
                                <div>
                                    <div className="d-flex">
                                        <select className="form-control" id="expiryDate" name="nftConfig.expiry.date" onChange={(e) => this.onChange(e)}
                                        // style={{
                                        //     padding: "7px 20px 7px 20px",
                                        //     border: "none",
                                        //     outline: "none",
                                        //     borderRadius: "4px",
                                        //     background: "#808080",
                                        //     display: "flex",
                                        //     alignItems: "center",
                                        //     justifyContent: "center",
                                        //     textAlign: "center",
                                        //     cursor: "pointer",
                                        //     height: "51px",
                                        //     color: "#000",
                                        //     boxShadow: "none"
                                        // }}
                                        >
                                            {
                                                expiryOptions && expiryOptions.map((expiry, index) => {
                                                    return (
                                                        <option key={index} value={expiry.value} >{expiry.label}</option>
                                                    )
                                                })
                                            }
                                        </select>

                                        <div className="mr-auto budle-wrapper">
                                            <input type={nftConfig.expiry.type === 1 ? "time" : "datetime-local"}
                                                //  style={{ marginLeft: "1rem", width: "552px" }} 
                                                name="nftConfig.expiry.time" value={nftConfig.expiry.time} onChange={(e) => this.onChange(e)} required />
                                        </div>
                                        <span className="text-danger message">{this.validator.message('expiryTime', nftConfig.expiry.time, 'required')}</span>

                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Body className="justify-content-center align-items-center">
                                <div className="d-flex justify-content-around">
                                    <button className="btn btn-bordered-white mr-3 mt-5 mb-3" disabled={loader} onClick={() => this.submit()}>{nft.sellingMethod === 2 ? initData.bidBtn : initData.offerBtn}</button>
                                    {/* <button className="ethereum-btn">Add funds</button> */}
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <button
                                    className="btn banner-btn btn-bordered-white"
                                    onClick={this.closeModal}
                                >
                                    Close
                                </button>
                            </Modal.Footer>
                        </Modal>
                    }
                </div>
            </>
        );
    }
}

const mapStateToProps = state => ({
    nft: state.nft,
    error: state.error,
    offer: state.offer,
    bid: state.bid,
    app: state.app,
    nftHistory: state.nftHistory
});

export default connect(mapStateToProps, {
    beforeNFT, getNFT,
    beforeOffer, makeOffer, getOffers, deleteOffer, beforeBid, placeBid, getBids, deleteBid, acceptOffer, acceptBid,
    beforeHistory, getHistory
})(ItemDetails);